module.exports = __webpack_public_path__ + "img/23.b7454b58.jpg";